// extracted by mini-css-extract-plugin
module.exports = {"root":"ContactInfoBox_root__20tIu","buttonGroup":"ContactInfoBox_buttonGroup__1vsiK","contactButton":"ContactInfoBox_contactButton__2CgP7"};